import { FormulaDecimal } from './decimal.js';
/** A null Boolean counts as false in a condition (§4.4). */
export function truthy(value) {
    return value === true;
}
export function isDecimal(value) {
    return value instanceof FormulaDecimal;
}
export function isRows(input) {
    return Array.isArray(input);
}
/** The value as the number an operation needs; a checked tree never fails this. */
export function requireDecimal(value, where) {
    if (isDecimal(value))
        return value;
    throw new Error(`'${where}' needs a number; got ${describeValue(value)}.`);
}
/** The value as the date an operation needs; a checked tree never fails this. */
export function requireDate(value, where) {
    if (value instanceof Date)
        return value;
    throw new Error(`'${where}' needs a date; got ${describeValue(value)}.`);
}
export function describeValue(value) {
    if (value === null)
        return 'null';
    if (isDecimal(value))
        return `number ${value.toString()}`;
    return `${typeof value} ${String(value)}`;
}
/** Normalizes a host input: undefined is null, a JSON number becomes a decimal through its shortest text. A collection is not a value. */
export function toValue(input) {
    if (input === undefined)
        return null;
    if (typeof input === 'number')
        return new FormulaDecimal(input);
    if (isRows(input))
        throw new Error('A collection is not a value; only an aggregate reads its rows.');
    return input;
}
